import { CornerFlourish } from '../ornaments/Vignette.tsx';
import type { ReactNode } from 'react';
import * as styles from './Cartouche.css.ts';

interface CartoucheProps {
  /** Heading content; rendered as the given heading level. */
  children: ReactNode;
  level?: 1 | 2;
  /** Small capitals line above the title. */
  kicker?: ReactNode;
  /** Italic line below the title. */
  subtitle?: ReactNode;
  size?: 'md' | 'lg';
  /** `sea` when the cartouche sits directly on the dark chart rather than on paper. */
  tone?: 'paper' | 'sea';
  id?: string;
}

/** A title framed as a chart cartouche: engraved double frame with scroll-work corners. */
export function Cartouche({
  children,
  level = 1,
  kicker,
  subtitle,
  size = 'md',
  tone = 'paper',
  id,
}: CartoucheProps) {
  const Heading = level === 1 ? 'h1' : 'h2';
  return (
    <div className={styles.frame({ size, tone })}>
      {(['tl', 'tr', 'bl', 'br'] as const).map((corner) => (
        <CornerFlourish key={corner} className={styles.corner[corner]} color="#2F2418" />
      ))}
      {kicker ? <p className={styles.kicker}>{kicker}</p> : null}
      <Heading id={id} className={styles.title({ size })}>
        {children}
      </Heading>
      {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
    </div>
  );
}
